import * as React from 'react';
import ImageLightbox, { ILightBoxProps as IImageLightBoxProps } from 'react-image-lightbox';
import { SITEGEN_WIDGET_CN } from '@sitegen/common/constants/styles';
import { Icon, ICON_NAME } from 'components/icon';
import 'react-image-lightbox/style.css';
import './lightbox.styles.less';

export class Lightbox extends React.Component<IImageLightBoxProps> {
    public getParentSelector = () =>
        document.querySelector(SITEGEN_WIDGET_CN) || document.body;

    public getDefaultToolbarsButtons = () => {
        return [
            (
                <div
                    onClick={this.props.onCloseRequest}
                    className="sitegen-lightbox__close"
                    key="close"
                >
                    <Icon name={ICON_NAME.CLOSE} />
                </div>
            )
        ];
    };

    public render() {
        const { reactModalProps = {}, toolbarButtons } = this.props;
        return (
            <ImageLightbox
                { ...this.props }
                enableZoom={ false }
                reactModalProps={{
                    parentSelector: this.getParentSelector,
                    overlayClassName: 'sitegen-lightbox__overlay',
                    ...reactModalProps,
                }}
                wrapperClassName="sitegen-lightbox"
                toolbarButtons={ toolbarButtons || this.getDefaultToolbarsButtons() }
            />
        );
    }
}

export {
    ImageLightbox
};
